import { render, staticRenderFns } from "./QuantityDetails.vue?vue&type=template&id=bc3c7980&"
import script from "./QuantityDetails.vue?vue&type=script&lang=js&"
export * from "./QuantityDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuantityDetails.vue?vue&type=style&index=0&id=bc3c7980&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports